import { createContext, useContext } from "react";
import type { InProcessV2026RowOpts } from "./inProcessMisconductV2026Rows";

export type InProcessMisconductV2026RowContextValue = InProcessV2026RowOpts;

const InProcessMisconductV2026RowContext =
  createContext<InProcessMisconductV2026RowContextValue | null>(null);

export function InProcessMisconductV2026RowProvider({
  value,
  children,
}: {
  value: InProcessMisconductV2026RowContextValue;
  children: React.ReactNode;
}) {
  return (
    <InProcessMisconductV2026RowContext.Provider value={value}>
      {children}
    </InProcessMisconductV2026RowContext.Provider>
  );
}

export function useInProcessMisconductV2026RowContext(): InProcessMisconductV2026RowContextValue {
  const ctx = useContext(InProcessMisconductV2026RowContext);
  if (!ctx) {
    throw new Error(
      "useInProcessMisconductV2026RowContext must be used within InProcessMisconductV2026RowProvider"
    );
  }
  return ctx;
}
